import { default as hideOnScrollDown } from './hideOnScrollDown';
export default {
  hideOnScrollDown: hideOnScrollDown
};